exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gap-5[data-v-bcc0fcfe] {\n  gap: 5px;\n}\n.gap-10[data-v-bcc0fcfe] {\n  gap: 10px;\n}\n.custom-modal[data-v-bcc0fcfe] {\n  max-width: 1200px;\n}\n.item-select[data-v-bcc0fcfe] {\n  display: flex;\n  align-items: center;\n  font-weight: 600;\n  height: 30px;\n  letter-spacing: 0.01em;\n  color: rgba(6, 38, 62, 0.74);\n}\n", ""]);

// exports
